// Import
import $ixios from '../shared/ixios-instance.js'


export default {
  /* *****************************************************************************************************
  * State
  */
  state: {
    address: {}
  },
  /* *****************************************************************************************************
  * Mutations
  * list of mutations
  */
  mutations: {
    /* ***********************************************************
    * Set address
    *
    */
    address (state, content) {
      state.address = content;
    }
  },
  /*****************************************************************************
  * Actions
  *
  */
  actions: {
    /* ***********************************************************
    * Case
    */
    address ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        $ixios.get('json', {params: payload} )
          .then(response => {
            //
            commit('address', response.data.data)
            resolve(response)
          })
          .catch(error => {
            commit('address', {})
            reject(error)
          })
      })
    }
  }
}
